import 'rxjs/add/observable/of';
import { isNullOrUndefined } from "util";
var NavigationService = /** @class */ (function () {
    function NavigationService() {
    }
    NavigationService.prototype.setCriteres = function (crit) {
        sessionStorage.setItem('criteres', JSON.stringify(crit));
    };
    NavigationService.prototype.getCriteres = function () {
        return JSON.parse(sessionStorage.getItem('criteres'));
    };
    NavigationService.prototype.setToken = function (token) {
        sessionStorage.setItem('token', JSON.stringify(token));
    };
    NavigationService.prototype.getToken = function () {
        var str = sessionStorage.getItem('token');
        if (isNullOrUndefined(str)) {
            return null;
        }
        return JSON.parse(str);
    };
    return NavigationService;
}());
export { NavigationService };



// WEBPACK FOOTER //
// ./src/app/shared/navigation.service.ts.pre-build-optimizer.js